// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1cjrK","inputWrap":"Table_inputWrap__vEHzc","col":"Table_col__2YEg3","bmiTooltip":"Table_bmiTooltip__2Mvgy"};